import styled from '@emotion/styled';
import { BaseButton, Variables } from '../../base';

export const Scrollable = styled.div`
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
`;

export const CloseTaskRow = styled.div`
    display: flex;
    justify-content: flex-start;
    padding: 8px 24px 16px;
`;

export const CloseTaskLink = styled(BaseButton)`
    display: inline-flex;
    align-items: center;
    align-self: flex-start;
    gap: 4px;
    min-width: unset;
    height: auto;
    padding: 0;
    background: transparent;
    background-color: transparent;
    border: none;
    border-radius: 0;
    font-size: 13px;
    font-weight: ${Variables.FontWeight.semibold};
    color: ${Variables.ThemeLight.PrimaryConstant6};
    cursor: pointer;

    &:hover:not(:disabled) {
        text-decoration: underline;
        background: transparent;
        background-color: transparent;
    }

    &:disabled {
        color: ${Variables.ThemeLight.TextMild};
        cursor: default;
        background: transparent;
        background-color: transparent;
    }
`;

export const GateRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    flex: none;
    padding: 10px 16px 12px;
    border-top: 1px solid ${Variables.ThemeLight.Border2};
`;

export const GateButton = styled(BaseButton)`
    display: inline-flex;
    align-items: center;
    align-self: flex-start;
    gap: 6px;
    white-space: nowrap;
    flex: none;
    min-width: unset;
    height: 36px;
    padding: 0 14px;
    font-size: 13px;
    font-weight: ${Variables.FontWeight.semibold};
    color: ${Variables.ThemeLight.TextMedium};
    background: ${Variables.ThemeLight.Background2};
    background-color: ${Variables.ThemeLight.Background2};
    border: 1px solid ${Variables.ThemeLight.Border2};
    border-radius: 999px;
    cursor: pointer;

    svg {
        fill: ${Variables.ThemeLight.TextMild};
    }

    &:hover:not(:disabled) {
        background: ${Variables.ThemeLight.NeutralMild1};
        background-color: ${Variables.ThemeLight.NeutralMild1};
    }

    &:disabled {
        opacity: 0.65;
        cursor: default;
    }
`;

export const ComposerShell = styled.div`
    flex: none;
    display: flex;
    flex-direction: column;
    border-top: 1px solid ${Variables.ThemeLight.Border2};
    background: ${Variables.ThemeLight.Background2};

    /* ChatControls already paints its own top border / padding when standalone */
    & > *:last-child {
        border-top: none;
    }
`;

export const ComposerToolbar = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px 0 8px;
`;

export const CollapseComposerButton = styled(BaseButton)`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: unset;
    width: 28px;
    height: 28px;
    padding: 0;
    border: none;
    border-radius: 6px;
    background: transparent;
    background-color: transparent;
    cursor: pointer;

    &:hover:not(:disabled) {
        background: ${Variables.ThemeLight.NeutralMild1};
        background-color: ${Variables.ThemeLight.NeutralMild1};
    }
`;
